import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { TreeViewService } from '@core/components/fc-tree-view/fc-tree-view.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { LocationTabLinksService } from 'app/main/locations/dialogs/dialog-location/tabs/links/tab-links.service';
import { uniqBy } from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { sentry } from 'sentry';
import { TabLinksService } from '../tab-links.service';
import { DialogLinkService } from './dialog-link.service';
var DialogLinkComponent = /** @class */ (function () {
    function DialogLinkComponent(dialogData, tabLinksService, treeViewService, dialogLinkService, changeDetectorRef, messageService, matDialogRef, locationLinksTabModalService, authenticationService) {
        this.dialogData = dialogData;
        this.tabLinksService = tabLinksService;
        this.treeViewService = treeViewService;
        this.dialogLinkService = dialogLinkService;
        this.changeDetectorRef = changeDetectorRef;
        this.messageService = messageService;
        this.matDialogRef = matDialogRef;
        this.locationLinksTabModalService = locationLinksTabModalService;
        this.authenticationService = authenticationService;
        this.isEmpty = false;
        this.isLoading = true;
        this.searchControl = new FormControl();
        this.equipments = [];
        this.locationSectors = [];
        this.locationEnvironments = [];
        this.allEquipments = [];
        this.allLocationSectors = [];
        this.allLocationEnvironments = [];
        this.locationLinks = [];
        this.unlinkedEquipments = [];
        this.destroy$ = new Subject();
        this.dialogLinkService.linkedSectors = this.dialogData.linkedSectors;
        this.dialogLinkService.linkedEquipments = this.dialogData.linkedEquipments;
        this.dialogLinkService.linkedEnvironments = this.dialogData.linkedEnvironments;
    }
    DialogLinkComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadLocationLinks()];
                    case 1:
                        _a.sent();
                        this.searchControl.valueChanges
                            .pipe(takeUntil(this.destroy$), debounceTime(300))
                            .subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a, sectors, environments, equipments;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = this.dialogLinkService.getLinkedItems({
                                            locationLinks: this.locationLinks,
                                            unlinkedEquipments: this.unlinkedEquipments,
                                            allSectors: this.allLocationSectors,
                                            allEquipments: this.allEquipments,
                                            allEnvironments: this.allLocationEnvironments,
                                        }), sectors = _a.sectors, environments = _a.environments, equipments = _a.equipments;
                                        this.dialogLinkService.linkedSectors = sectors;
                                        this.dialogLinkService.linkedEquipments = equipments;
                                        this.dialogLinkService.linkedEnvironments = environments;
                                        return [4 /*yield*/, this.loadLocationLinks()];
                                    case 1:
                                        _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.treeViewService.checked$
                            .pipe(takeUntil(this.destroy$))
                            .subscribe(function (item) {
                            if (item.metadata === 'sector') {
                                var linkedSector = _this.dialogLinkService.linkedSectors.find(function (linkedItem) { return linkedItem.id === item.id; });
                                if (!linkedSector) {
                                    if (item.action.checked) {
                                        _this.dialogLinkService.linkedSectors.push(item.original);
                                    }
                                    return;
                                }
                                if (!item.action.checked) {
                                    _this.dialogLinkService.linkedSectors = _this.dialogLinkService.linkedSectors.filter(function (linkedItem) { return linkedItem.id !== item.id; });
                                    _this.dialogLinkService.linkedEnvironments = _this.dialogLinkService.linkedEnvironments.filter(function (linkedItem) { return linkedItem.locationSector.id !== item.id; });
                                    _this.dialogLinkService.linkedEquipments = _this.dialogLinkService.linkedEquipments.filter(function (linkedItem) { return !linkedItem.locationSector || linkedItem.locationSector.id !== item.id; });
                                }
                            }
                            if (item.metadata === 'environment') {
                                var linkedEnvironment = _this.dialogLinkService.linkedEnvironments.find(function (linkedItem) { return linkedItem.id === item.id; });
                                if (!linkedEnvironment) {
                                    if (item.action.checked) {
                                        _this.dialogLinkService.linkedEnvironments.push(item.original);
                                    }
                                    return;
                                }
                                if (!item.action.checked) {
                                    _this.dialogLinkService.linkedEnvironments = _this.dialogLinkService.linkedEnvironments.filter(function (linkedItem) { return linkedItem.id !== item.id; });
                                    _this.dialogLinkService.linkedEquipments = _this.dialogLinkService.linkedEquipments.filter(function (linkedItem) { return !linkedItem.locationEnvironment || linkedItem.locationEnvironment.id !== item.id; });
                                }
                            }
                            if (item.metadata === 'equipment') {
                                var linkedEquipment = _this.dialogLinkService.linkedEquipments.find(function (linkedItem) { return linkedItem.id === item.id; });
                                if (!linkedEquipment) {
                                    if (item.action.checked) {
                                        _this.dialogLinkService.linkedEquipments.push(item.original);
                                    }
                                    return;
                                }
                                if (!item.action.checked) {
                                    _this.dialogLinkService.linkedEquipments = _this.dialogLinkService.linkedEquipments.filter(function (linkedItem) { return linkedItem.id !== item.id; });
                                }
                            }
                        });
                        this.treeViewService.checkAll$
                            .pipe(takeUntil(this.destroy$))
                            .subscribe(function () {
                            _this.locationLinks.forEach(function (sector) {
                                sector.action.checked = true;
                                if (sector.children && sector.children.length) {
                                    sector.children.forEach(function (environmentOrEquipment) {
                                        environmentOrEquipment.action.checked = true;
                                        if (environmentOrEquipment.children && environmentOrEquipment.children.length) {
                                            environmentOrEquipment.children.forEach(function (equipment) {
                                                equipment.action.checked = true;
                                            });
                                        }
                                    });
                                }
                            });
                            _this.unlinkedEquipments.forEach(function (equipment) {
                                equipment.action.checked = true;
                                equipment.children.forEach(function (eq) {
                                    eq.action.checked = true;
                                });
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLinkComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    DialogLinkComponent.prototype.checkAll = function () {
        this.treeViewService.checkAll$.next();
        this.changeDetectorRef.markForCheck();
    };
    DialogLinkComponent.prototype.save = function () {
        var result = this.dialogLinkService.getLinkedItems({
            locationLinks: this.locationLinks,
            unlinkedEquipments: this.unlinkedEquipments,
            allSectors: this.allLocationSectors,
            allEquipments: this.allEquipments,
            allEnvironments: this.allLocationEnvironments,
        });
        this.matDialogRef.close(result);
    };
    DialogLinkComponent.prototype.loadLocationLinks = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, unlinkedEquipments;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.searchLocationSectorsWithEnvironmentsAndEquipments().catch(function (error) {
                                _this.messageService.error('UNKNOWN_ERROR');
                                console.error(error);
                                sentry.captureException(error);
                                return [];
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.searchEquipments().catch(function (error) {
                                _this.messageService.error('UNKNOWN_ERROR');
                                console.error(error);
                                sentry.captureException(error);
                                return [];
                            })];
                    case 2:
                        unlinkedEquipments = _a.sent();
                        return [4 /*yield*/, this.populateLocationLinks({
                                locationSectors: response,
                                unlinkedEquipments: unlinkedEquipments
                            })];
                    case 3:
                        _a.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLinkComponent.prototype.searchLocationSectorsWithEnvironmentsAndEquipments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinksTabModalService.searchLocationSectorsWithEnvironmentsAndEquipments({
                        locationId: this.dialogData.locationId,
                        archived: false,
                        nameOrEnvironmentNameContains: this.searchControl.value,
                    })];
            });
        });
    };
    DialogLinkComponent.prototype.searchEquipments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params;
            return tslib_1.__generator(this, function (_a) {
                params = {
                    locationId_in: [this.dialogData.locationId],
                    segmentId_in: [this.dialogData.segmentId],
                    name_or_number_contains: this.searchControl.value,
                    archived: false,
                    hasLocationEnvironment: false,
                    hasLocationSector: false
                };
                return [2 /*return*/, this.locationLinksTabModalService.searchEquipmentsWithWarranties(params)];
            });
        });
    };
    DialogLinkComponent.prototype.populateLocationLinks = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var locationSectors, locationEnvironments, equipmentsWithoutEnvironment, equipmentsWithEnvironment, equipments, concatLocationSectors, concatLocationEnvironments, concatEquipments, uniqueSectors, uniqueEnvironments, uniqueEquipments, data, _a, sectors, unlinkedEquipments, unfilteredLocationLinks, unfilteredUnlinkedEquipments;
            return tslib_1.__generator(this, function (_b) {
                locationSectors = params.locationSectors;
                locationEnvironments = locationSectors.map(function (sector) { return sector.locationEnvironments || []; }).reduce(function (acc, curr) { return acc.concat(curr); }, []);
                equipmentsWithoutEnvironment = locationSectors.map(function (env) { return env.equipmentsWithoutEnvironment || []; }).reduce(function (acc, curr) { return acc.concat(curr); }, []);
                equipmentsWithEnvironment = locationEnvironments.map(function (env) { return env.equipments || []; }) || [].reduce(function (acc, curr) { return acc.concat(curr); }, []);
                equipments = tslib_1.__spread(equipmentsWithEnvironment, equipmentsWithoutEnvironment, params.unlinkedEquipments);
                if (!this.searchControl.value) {
                    this.allEquipments = equipments;
                    this.allLocationSectors = locationSectors;
                    this.allLocationEnvironments = locationEnvironments;
                }
                this.equipments = equipments;
                this.locationSectors = locationSectors;
                this.locationEnvironments = locationEnvironments;
                concatLocationSectors = tslib_1.__spread((this.locationSectors.concat(this.allLocationSectors)));
                concatLocationEnvironments = tslib_1.__spread((this.locationEnvironments.concat(this.allLocationEnvironments)));
                concatEquipments = tslib_1.__spread((this.equipments.concat(this.allEquipments)));
                uniqueSectors = uniqBy(concatLocationSectors || [], 'id');
                uniqueEnvironments = uniqBy(concatLocationEnvironments || [], 'id');
                uniqueEquipments = uniqBy(concatEquipments || [], 'id');
                data = {
                    sectors: uniqueSectors,
                    environments: uniqueEnvironments,
                    equipments: uniqueEquipments,
                };
                _a = this.tabLinksService.sortAllByArchivedThenByName(uniqueSectors, params.unlinkedEquipments), sectors = _a.sectors, unlinkedEquipments = _a.unlinkedEquipments;
                unfilteredLocationLinks = this.dialogLinkService.formatSectors({ sectors: sectors, data: data });
                unfilteredUnlinkedEquipments = this.dialogLinkService.formatUnlinkedEquipments({ unlinkedEquipments: unlinkedEquipments });
                this.locationLinks = this.tabLinksService.filter(unfilteredLocationLinks, this.searchControl.value);
                this.unlinkedEquipments = this.tabLinksService.filter(unfilteredUnlinkedEquipments, this.searchControl.value);
                this.isEmpty = !this.locationLinks.length && !this.unlinkedEquipments.length;
                return [2 /*return*/];
            });
        });
    };
    return DialogLinkComponent;
}());
export { DialogLinkComponent };
